export default __webpack_public_path__ + "static/media/connect_pers.3d04e54d.svg";